// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".motoboy-add-order-list__item[data-v-4dc57298] {\n  gap: 0.5rem;\n}[dir] .motoboy-add-order-list__item[data-v-4dc57298] {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #ebe9f1;\n}\n[dir] .motoboy-add-order-list__item[data-v-4dc57298]:last-child {\n  border-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
